export default __webpack_public_path__ + "static/media/nodejs.2b068858.png";